import type { LucideIcon } from 'lucide-react'

const ACCENTS: Record<string, string> = {
  jr2: 'bg-jr2-500/15 text-jr2-700 dark:text-jr2-300',
  blue: 'bg-blue-500/15 text-blue-700 dark:text-blue-300',
  emerald: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
  amber: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  rose: 'bg-rose-500/15 text-rose-700 dark:text-rose-300',
}

export function StatBox({
  label,
  value,
  icon: Icon,
  accent,
  hint,
}: {
  label: string
  value: string
  icon: LucideIcon
  accent: keyof typeof ACCENTS | string
  hint?: string
}) {
  return (
    <div className="surface p-4 flex items-start gap-3">
      <div
        className={`w-10 h-10 rounded-lg grid place-items-center shrink-0 ${ACCENTS[accent] ?? ACCENTS.jr2}`}
      >
        <Icon size={18} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] uppercase tracking-wider t-muted">{label}</div>
        <div className="text-xl font-semibold t-primary mt-0.5 font-mono truncate text-right">
          {value}
        </div>
        {hint && <div className="text-[10px] t-faint mt-0.5 text-right">{hint}</div>}
      </div>
    </div>
  )
}
